import { Cache } from "./Cache";
import type { XMLHttpRequestProcessed } from "@otto-ec/global-resources";

const TEMPLATE_URL = "/stomachshop/";

export function templateResponseHandler(xhr: XMLHttpRequestProcessed): string {
  if (xhr.status !== 200) {
    throw new Error("received status code " + xhr.status);
  }

  if (!xhr.response && !xhr.responseText) {
    throw new Error("No template found");
  }

  return xhr.response || xhr.responseText;
}

export function retrieveTemplate(name: string): Promise<string> {
  return window.o_util.ajax.get(TEMPLATE_URL + name + ".mustache").then(templateResponseHandler);
}

export const templates = new Cache<Promise<string>>(retrieveTemplate);
